import React from 'react'
import { Link } from 'react-router-dom';
import news from '../News/news.json';
import refIcon from '../../assets/images/home/ref-icon.png'
import newsImage from '../../assets/images/home/undraw01.svg'

function HeroSection() {
    return (

        <React.Fragment>
            <div>
                <div className="hero">
                    <div className="inner description">
                        <div className="home-hero-info view">
                            <h2 className="home-hero-info-title">
                                <span className="first-text">SMART<br />TECH</span>
                                <img src={refIcon} className="rotate linear infinite" alt="arrow-icon"></img>
                            </h2>
                            <p className="home-hero-info-lead first">企業の未来が変わる。</p>
                            <p className="home-hero-info-lead second">すみやかに、確実に、スマートに。
                            </p>
                            <p className="home-hero-info-text">
                                さまざまなビジネスシーンにおける“あったらいいな”。<br />
                                今はまだ存在しないこのアイデアを大切に預かり、<br />
                                形あるものへと実現させることが、私たちの仕事です。<br />
                                ソフトウェアで、企業の新しい一歩を。<br />
                            </p>
                        </div>
                    </div>
                </div>
                <div className="home-newsblock view">
                    <div className="col news-link-col">
                        <h2 className="home-newsblock-title">NEWS</h2>
                        <ul className="home-newsblock-list">
                            <li className="home-newsblock-item">
                                <div className="home-newsblock-item-link">
                                    <Link to={`/news/${news.news[0].id}`}>
                                        <span className="time">{news.news[0].date}</span>
                                        <span>{news.news[0].title}</span>
                                    </Link>
                                </div>
                            </li>
                            <li className="home-newsblock-item">
                                <div className="home-newsblock-item-link">
                                    <Link to={`/news/${news.news[1].id}`}>
                                        <span className="time">{news.news[1].date}</span>
                                        <span>{news.news[1].title}</span>
                                    </Link>
                                </div>
                            </li>
                            <li className="home-newsblock-item">
                                <div className="home-newsblock-item-link">
                                    <Link to={`/news/${news.news[2].id}`}>
                                        <span className="time">{news.news[2].date}</span>
                                        <span>{news.news[2].title}</span>
                                    </Link>
                                </div>
                            </li>
                        </ul>
                        <div className="home-newsblock-more">
                            <Link to="/news" className="home-newsblock-more-link">一覧を見る</Link>
                        </div>
                    </div>
                    <div className="image-holder col">
                        <img src={newsImage} alt="newsIllustrations"></img>
                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}

export default HeroSection
